import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TopUpUIHelpers";

const TopUpUIContext = createContext();

export function useTopUpUIContext() {
  return useContext(TopUpUIContext);
}

export const TopUpUIConsumer = TopUpUIContext.Consumer;

export function TopUpUIProvider({ topUpUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initTopUp = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initTopUp,
    newTopUpIndividuButtonClick: topUpUIEvents.newTopUpIndividuButtonClick,
    openEditTopUpIndividualPage: topUpUIEvents.openEditTopUpIndividualPage,
    openEditTopUpOrganizationPage: topUpUIEvents.openEditTopUpOrganizationPage,
    openDeleteTopUpPage: topUpUIEvents.openDeleteTopUpPage,
    newTopUpOrganizationButtonClick:
      topUpUIEvents.newTopUpOrganizationButtonClick,
  };

  return (
    <TopUpUIContext.Provider value={value}>{children}</TopUpUIContext.Provider>
  );
}
